export interface A1ExpansionCandidate {
  id: string;
  label: string;
  kind: 'adjoining' | 'satellite';
  statedAcres: number | null;
  screenedCampusAcres: number | null;
  distanceFromA1Miles: number;
  distanceToPipelineMiles: number;
  onInventoryMiles: number | null;
  outsideInventoryMiles: number | null;
  geometry: GeoJSON.Geometry;
  connectorGeometry: GeoJSON.Geometry | null;
  summary: string;
  nextAction: string;
  knownFacts: string[];
  openQuestions: string[];
}

export interface A1ExpansionStudyData {
  schemaVersion: 1;
  asOf: string;
  anchor: {
    id: string;
    label: string;
    statedAcres: number;
    measuredAcres: number;
    basis: string;
    geometry: GeoJSON.Geometry;
  };
  corridor: { label: string; pipelineId: string; geometry: GeoJSON.Geometry };
  candidates: A1ExpansionCandidate[];
  operatorContext: { summary: string; basis: string };
  methodNotes: string[];
  sources: { label: string; date: string; detail: string }[];
}

export async function fetchA1ExpansionStudy(signal?: AbortSignal): Promise<A1ExpansionStudyData> {
  const password = typeof window !== 'undefined' ? localStorage.getItem('pp-auth') : null;
  const response = await fetch('/api/crownpine-expansion', {
    headers: password ? { Authorization: `Bearer ${password}` } : {},
    cache: 'no-store',
    signal,
  });
  if (!response.ok) {
    throw new Error(response.status === 401 || response.status === 403
      ? 'Sign in with owner access to view the expansion study.'
      : 'The expansion study could not be loaded. Try again.');
  }
  return response.json();
}
